import i18n from 'i18next'
import translationDE from 'locales/de/translationDE.json'
import translationEN from 'locales/en/translationEN.json'
import { initReactI18next } from 'react-i18next'

const resources = {
  en: {
    translation: translationEN,
  },
  de: {
    translation: translationDE,
  },
}

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
